import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VToolbar,{staticClass:"baseToolbar",attrs:{"text":"","dark":"","color":"light-blue darken-4","flat":_vm.isFlat}},[_c(VToolbarTitle,{staticClass:"baseToolbar_title"},[_vm._v("\n    "+_vm._s(_vm.toolbarTitle)+"\n  ")]),_c(VSpacer),_vm._t("toolbarSearch"),_c(VSpacer),_vm._t("toolbarBtn")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }